// import { call, takeLatest } from "redux-saga/effects";
// import { IAction } from "store/store-models";
// import { LOGIN } from "./saga-actions";

function* coreSaga() {}

export default coreSaga;
